import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';
import {saveFile} from "../lib/content-lib";

export const GET_PURCHASE_INVOICES_REQUEST = 'GET_PURCHASE_INVOICES_REQUEST';
export const GET_PURCHASE_INVOICES_SUCCESS = 'GET_PURCHASE_INVOICES_SUCCESS';
export const GET_PURCHASE_INVOICES_ERROR = 'GET_PURCHASE_INVOICES_ERROR';

export const GET_PURCHASE_INVOICE_REQUEST = 'GET_PURCHASE_INVOICE_REQUEST';
export const GET_PURCHASE_INVOICE_SUCCESS = 'GET_PURCHASE_INVOICE_SUCCESS';
export const GET_PURCHASE_INVOICE_ERROR = 'GET_PURCHASE_INVOICE_ERROR';

export const CREATE_PURCHASE_INVOICE_REQUEST = 'CREATE_PURCHASE_INVOICE_REQUEST';
export const CREATE_PURCHASE_INVOICE_SUCCESS = 'CREATE_PURCHASE_INVOICE_SUCCESS';
export const CREATE_PURCHASE_INVOICE_ERROR = 'CREATE_PURCHASE_INVOICE_ERROR';

export const UPDATE_PURCHASE_INVOICE_REQUEST = 'UPDATE_PURCHASE_INVOICE_REQUEST';
export const UPDATE_PURCHASE_INVOICE_SUCCESS = 'UPDATE_PURCHASE_INVOICE_SUCCESS';
export const UPDATE_PURCHASE_INVOICE_ERROR = 'UPDATE_PURCHASE_INVOICE_ERROR';

export const CHANGE_STATUS_PURCHASE_INVOICE_REQUEST = 'CHANGE_STATUS_PURCHASE_INVOICE_REQUEST';
export const CHANGE_STATUS_PURCHASE_INVOICE_SUCCESS = 'CHANGE_STATUS_PURCHASE_INVOICE_SUCCESS';
export const CHANGE_STATUS_PURCHASE_INVOICE_ERROR = 'CHANGE_STATUS_PURCHASE_INVOICE_ERROR';

export const UPLOAD_PURCHASE_INVOICE_FILES_REQUEST = 'UPLOAD_PURCHASE_INVOICE_FILES_REQUEST';
export const UPLOAD_PURCHASE_INVOICE_FILES_PROGRESS = 'UPLOAD_PURCHASE_INVOICE_FILES_PROGRESS';
export const UPLOAD_PURCHASE_INVOICE_FILES_SUCCESS = 'UPLOAD_PURCHASE_INVOICE_FILES_SUCCESS';
export const UPLOAD_PURCHASE_INVOICE_FILES_ERROR = 'UPLOAD_PURCHASE_INVOICE_FILES_ERROR';

export const DELETE_PURCHASE_INVOICE_FILE_REQUEST = 'DELETE_PURCHASE_INVOICE_FILE_REQUEST';
export const DELETE_PURCHASE_INVOICE_FILE_SUCCESS = 'DELETE_PURCHASE_INVOICE_FILE_SUCCESS';
export const DELETE_PURCHASE_INVOICE_FILE_ERROR = 'DELETE_PURCHASE_INVOICE_FILE_ERROR';

export const DELETE_PURCHASE_INVOICE_REQUEST = 'DELETE_PURCHASE_INVOICE_REQUEST';
export const DELETE_PURCHASE_INVOICE_SUCCESS = 'DELETE_PURCHASE_INVOICE_SUCCESS';
export const DELETE_PURCHASE_INVOICE_ERROR = 'DELETE_PURCHASE_INVOICE_ERROR';

export const CLEAN_PURCHASE_INVOICES = 'CLEAN_PURCHASE_INVOICES';

// Get purchaseInvoices
export function getPurchaseInvoices(query) {
    return async (dispatch) => {
        try {
            dispatch(getPurchaseInvoicesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/purchase-invoices/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getPurchaseInvoicesSuccess, getPurchaseInvoicesError));
        } catch (err) {
            dispatch(utilsLib.response(err, getPurchaseInvoicesError));
        }
    };
}
function getPurchaseInvoicesRequest() {
    return {
        type: GET_PURCHASE_INVOICES_REQUEST,
        isFetching: true
    };
}
function getPurchaseInvoicesSuccess (payload) {
    return {
        type: GET_PURCHASE_INVOICES_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getPurchaseInvoicesError(errorMessage) {
    return {
        type: GET_PURCHASE_INVOICES_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get purchaseInvoice
export function getPurchaseInvoice(purchaseInvoiceId) {

    return async (dispatch) => {
        try {
            dispatch(getPurchaseInvoiceRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/purchase-invoices/${purchaseInvoiceId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getPurchaseInvoiceSuccess, getPurchaseInvoiceError));
        } catch (err) {
            dispatch(utilsLib.response(err, getPurchaseInvoiceError));
        }
    };
}
function getPurchaseInvoiceRequest() {
    return {
        type: GET_PURCHASE_INVOICE_REQUEST,
        isFetching: true
    };
}
function getPurchaseInvoiceSuccess (payload) {
    return {
        type: GET_PURCHASE_INVOICE_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getPurchaseInvoiceError(errorMessage) {
    return {
        type: GET_PURCHASE_INVOICE_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create purchaseInvoice
export function createPurchaseInvoice(purchaseInvoice, options) {
    return async (dispatch) => {
        try {
            dispatch(createPurchaseInvoiceRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/purchase-invoices', {purchaseInvoice, options}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createPurchaseInvoiceSuccess, createPurchaseInvoiceError));
        } catch (err) {
            dispatch(utilsLib.response(err, createPurchaseInvoiceError));
        }
    };
}
function createPurchaseInvoiceRequest() {
    return {
        type: CREATE_PURCHASE_INVOICE_REQUEST,
        isFetching: true
    };
}
function createPurchaseInvoiceSuccess (payload) {
    return dispatch => {
        // Create notification for create purchaseInvoice success
        dispatch(addNotification({
            message: 'Factura añadida correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_PURCHASE_INVOICE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createPurchaseInvoiceError(errorMessage) {
    return dispatch => {
        // Create notification for create purchaseInvoice error
        dispatch(addNotification({
            message: 'Error al añadir la factura',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_PURCHASE_INVOICE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update purchaseInvoice
export function updatePurchaseInvoice(purchaseInvoiceId, purchaseInvoice = {}) {
    return async (dispatch) => {
        try {
            dispatch(updatePurchaseInvoiceRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/purchase-invoices/${purchaseInvoiceId}`, purchaseInvoice, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updatePurchaseInvoiceSuccess, updatePurchaseInvoiceError));
        } catch (err) {
            dispatch(utilsLib.response(err, updatePurchaseInvoiceError));
        }
    };
}
function updatePurchaseInvoiceRequest() {
    return {
        type: UPDATE_PURCHASE_INVOICE_REQUEST,
        isFetching: true
    };
}
function updatePurchaseInvoiceSuccess (payload) {
    return dispatch => {
        // Create notification for update purchaseInvoice success
        dispatch(addNotification({
            message: 'Factura actualizada correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_PURCHASE_INVOICE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updatePurchaseInvoiceError(errorMessage) {
    return dispatch => {
        // Create notification for update purchaseInvoice error
        dispatch(addNotification({
            message: 'Error al actualizar la factura',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_PURCHASE_INVOICE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Change purchaseInvoice status
export function changePurchaseInvoiceStatus(purchaseInvoiceId, status, options = { populateRefs: true, calculateStatistics: 'purchase-order' }) {
    return async (dispatch) => {
        try {
            dispatch(changePurchaseInvoiceStatusRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/purchase-invoices/${purchaseInvoiceId}/status`, { status, options }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changePurchaseInvoiceStatusSuccess, changePurchaseInvoiceStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, changePurchaseInvoiceStatusError));
        }
    };
}
function changePurchaseInvoiceStatusRequest() {
    return {
        type: CHANGE_STATUS_PURCHASE_INVOICE_REQUEST,
        isFetching: true
    };
}
function changePurchaseInvoiceStatusSuccess (payload) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_PURCHASE_INVOICE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function changePurchaseInvoiceStatusError(errorMessage) {
    return dispatch => {
        // Create notification for update status error
        dispatch(addNotification({
            message: 'Error al actualizar el estado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_PURCHASE_INVOICE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Upload purchaseInvoice files
export function uploadPurchaseInvoiceFiles(purchaseInvoiceId, files) {
    return async (dispatch) => {
        try {
            dispatch(uploadPurchaseInvoiceFilesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/purchase-invoices/${purchaseInvoiceId}/files`, files, {
                headers: { 'Authorization': 'Bearer ' + token },
                onUploadProgress: function (e) {
                    dispatch(uploadPurchaseInvoiceFilesProgress(e.loaded / e.total))
                }
            });

            dispatch(utilsLib.response(res, uploadPurchaseInvoiceFilesSuccess, uploadPurchaseInvoiceFilesError));
        } catch (err) {
            dispatch(utilsLib.response(err, uploadPurchaseInvoiceFilesError));
        }
    };
}
function uploadPurchaseInvoiceFilesRequest() {
    return {
        type: UPLOAD_PURCHASE_INVOICE_FILES_REQUEST,
        isFetching: true
    };
}
function uploadPurchaseInvoiceFilesProgress(percent) {
    return {
        type: UPLOAD_PURCHASE_INVOICE_FILES_PROGRESS,
        percent
    };
}
function uploadPurchaseInvoiceFilesSuccess (payload) {
    return dispatch => {
        // Create notification for upload purchaseInvoice file success
        dispatch(addNotification({
            message: 'Ficheros subidos correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPLOAD_PURCHASE_INVOICE_FILES_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function uploadPurchaseInvoiceFilesError(errorMessage) {
    return dispatch => {
        // Create notification for upload purchaseInvoice file error
        dispatch(addNotification({
            message: 'Error al subir los ficheros',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPLOAD_PURCHASE_INVOICE_FILES_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Download purchaseInvoice file
export function downloadPurchaseInvoiceFile(purchaseInvoiceId, fileId) {
    return async (dispatch) => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/purchase-invoices/${purchaseInvoiceId}/files/${fileId}`, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });

            if( res.status === 200 ) {
                saveFile(res);
            }

        } catch (err) {
            dispatch(addNotification({
                message: 'Error al descargar el fichero',
                color: 'red',
                icon: 'warning-sign'
            }));
        }
    };
}

// Delete purchaseInvoice file
export function deletePurchaseInvoiceFile(purchaseInvoiceId, fileId) {
    return async (dispatch) => {
        try {
            dispatch(deletePurchaseInvoiceFileRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/purchase-invoices/${purchaseInvoiceId}/files/${fileId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deletePurchaseInvoiceFileSuccess, deletePurchaseInvoiceFileError));
        } catch (err) {
            dispatch(utilsLib.response(err, deletePurchaseInvoiceFileError));
        }
    };
}
function deletePurchaseInvoiceFileRequest() {
    return {
        type: DELETE_PURCHASE_INVOICE_FILE_REQUEST,
        isFetching: true
    };
}
function deletePurchaseInvoiceFileSuccess (payload) {
    return dispatch => {
        // Create notification for delete file success
        dispatch(addNotification({
            message: 'Fichero eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_PURCHASE_INVOICE_FILE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deletePurchaseInvoiceFileError(errorMessage) {
    return dispatch => {
        // Create notification for delete file error
        dispatch(addNotification({
            message: 'Error al eliminar el fichero',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_PURCHASE_INVOICE_FILE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete purchaseInvoice
export function deletePurchaseInvoice(purchaseInvoiceId) {

    return async (dispatch) => {
        try {
            dispatch(deletePurchaseInvoiceRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/purchase-invoices/${purchaseInvoiceId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deletePurchaseInvoiceSuccess, deletePurchaseInvoiceError));
        } catch (err) {
            dispatch(utilsLib.response(err, deletePurchaseInvoiceError));
        }
    };
}
function deletePurchaseInvoiceRequest() {
    return {
        type: DELETE_PURCHASE_INVOICE_REQUEST,
        isFetching: true
    };
}
function deletePurchaseInvoiceSuccess (payload) {
    return dispatch => {
        // Create notification for delete purchaseInvoice success
        dispatch(addNotification({
            message: 'Factura eliminada correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_PURCHASE_INVOICE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deletePurchaseInvoiceError(errorMessage) {
    return dispatch => {
        // Create notification for delete purchaseInvoice error
        dispatch(addNotification({
            message: 'Error al eliminar la factura',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_PURCHASE_INVOICE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean purchaseInvoices reducer
export function cleanPurchaseInvoices() {
    return {
        type: 'CLEAN_PURCHASE_INVOICES',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/purchase-invoices.js